module.exports = __webpack_public_path__ + "img/tdf-logo-2026.4527f0fa.svg";